import { GET_USER_BY_INVITE_TOKEN } from 'actions/Types';

export default function inviteTokenExpired(state = false, action) {
  if (action.type === `${GET_USER_BY_INVITE_TOKEN}_FAILURE`) {
    return true;
  }

  return state;
}
